import React from "react";

function IntroScreen({
  backgroundImage,
  content,
  onNext,
  onReset,
  isLastStep = false,
  buttonText = "Next",
}) {
  // If this is the last step, use reset handler instead of next
  const handleClick = isLastStep && onReset ? onReset : onNext;
  // Override button text to "Reset" if on last step
  const displayText = isLastStep ? "Reset" : buttonText;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1000,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        background: `url(${backgroundImage}) center/cover no-repeat`,
      }}
    >
      <div
        style={{
          flexGrow: 1,
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        {content}
      </div>
      <button
        style={{
          position: "absolute",
          right: 60,
          bottom: 60,
          padding: "16px 32px",
          borderRadius: 10,
          background: "#0B9C57",
          color: "#fff",
          fontSize: "1.125rem",
          fontWeight: "600",
          border: "none",
          cursor: "pointer",
          zIndex: 10,
        }}
        onClick={handleClick}
      >
        {displayText}
      </button>
    </div>
  );
}

export default IntroScreen;
